import { abtastyService } from '@/services';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Header from './Header';
import Body from './Body';
import cx from '@utils/cx.util';

type Props = {
  className?: string;
};

const AccessoryUpsell = ({ className = '' }: Props) => {
  const upsell = useSelector((state: any) => state.pdpItem.upsell);
  const { title, subheader, members, selected, displayType } = upsell;
  const [isExpanded, setIsExpanded] = useState<boolean>(!!displayType && displayType !== 'collapsed');

  const toggleExpanded = () => {
    abtastyService.trackClick('Accessory Upsell: Toggle');
    setIsExpanded((prevState) => !prevState);
  };

  useEffect(() => {
    setIsExpanded(!!displayType && displayType !== 'collapsed');
  }, [displayType]);

  if (!upsell || !members || members?.length < 1) return null;

  return (
    <div
      className={cx(
        'tw:w-full tw:rounded-[10px] tw:border tw:border-neutrals-light-grey tw:bg-white tw:px-6 tw:py-3',
        className
      )}>
      <Header isExpanded={isExpanded} toggleIsExpanded={toggleExpanded} title={title} subheader={subheader} />
      <div
        className={cx({
          'tw:mt-3 tw:max-h-[1000px] tw:transition-all tw:duration-300': isExpanded,
          'tw:max-h-0 tw:overflow-hidden': !isExpanded,
        })}>
        <Body items={members} selected={selected} />
      </div>
    </div>
  );
};

export default memo(AccessoryUpsell);
